import React from 'react';
import { MapPin } from 'lucide-react';
import { Input } from '../ui/input';
import { Label } from '../ui/label';
import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from '../ui/select';

const COUNTRIES = [
  { code: 'FR', name: 'France' },
  { code: 'BE', name: 'Belgique' },
  { code: 'CH', name: 'Suisse' },
  { code: 'CA', name: 'Canada' },
  { code: 'GB', name: 'United Kingdom' },
  { code: 'DE', name: 'Deutschland' },
  { code: 'ES', name: 'España' },
  { code: 'IT', name: 'Italia' },
];

export const AddressForm = ({ address, onFieldChange, onCountrySelect, language, t }) => (
  <>
    <h2 className="text-xl font-bold mb-6 flex items-center gap-2">
      <MapPin className="w-5 h-5 text-[#0F4C5C]" />
      {language === 'fr' ? 'Adresse de livraison' : 'Shipping Address'}
    </h2>

    <div className="grid grid-cols-2 gap-4 mb-4">
      <div>
        <Label htmlFor="first_name">{t('firstName')} *</Label>
        <Input id="first_name" name="first_name" value={address.first_name} onChange={onFieldChange}
          className="mt-1" required data-testid="shipping-first-name" />
      </div>
      <div>
        <Label htmlFor="last_name">{t('lastName')} *</Label>
        <Input id="last_name" name="last_name" value={address.last_name} onChange={onFieldChange}
          className="mt-1" required data-testid="shipping-last-name" />
      </div>
    </div>

    <div className="mb-4">
      <Label htmlFor="address_line1">{language === 'fr' ? 'Adresse' : 'Address'} *</Label>
      <Input id="address_line1" name="address_line1" value={address.address_line1} onChange={onFieldChange}
        placeholder={language === 'fr' ? '123 Rue Example' : '123 Example Street'}
        className="mt-1" required data-testid="shipping-address" />
    </div>

    <div className="mb-4">
      <Label htmlFor="address_line2">{language === 'fr' ? 'Complément d\'adresse' : 'Address Line 2'}</Label>
      <Input id="address_line2" name="address_line2" value={address.address_line2} onChange={onFieldChange}
        placeholder={language === 'fr' ? 'Appartement, étage, etc.' : 'Apartment, floor, etc.'} className="mt-1" />
    </div>

    <div className="grid grid-cols-2 gap-4 mb-4">
      <div>
        <Label htmlFor="city">{language === 'fr' ? 'Ville' : 'City'} *</Label>
        <Input id="city" name="city" value={address.city} onChange={onFieldChange}
          className="mt-1" required data-testid="shipping-city" />
      </div>
      <div>
        <Label htmlFor="postal_code">{language === 'fr' ? 'Code postal' : 'Postal Code'} *</Label>
        <Input id="postal_code" name="postal_code" value={address.postal_code} onChange={onFieldChange}
          className="mt-1" required data-testid="shipping-postal" />
      </div>
    </div>

    <div className="grid grid-cols-2 gap-4 mb-6">
      <div>
        <Label htmlFor="country">{language === 'fr' ? 'Pays' : 'Country'} *</Label>
        <Select value={address.country} onValueChange={onCountrySelect}>
          <SelectTrigger className="mt-1" data-testid="shipping-country">
            <SelectValue />
          </SelectTrigger>
          <SelectContent>
            {COUNTRIES.map((c) => (
              <SelectItem key={c.code} value={c.code}>{c.name}</SelectItem>
            ))}
          </SelectContent>
        </Select>
      </div>
      <div>
        <Label htmlFor="phone">{language === 'fr' ? 'Téléphone' : 'Phone'} *</Label>
        <Input id="phone" name="phone" type="tel" value={address.phone} onChange={onFieldChange}
          placeholder="+33 6 12 34 56 78" className="mt-1" required data-testid="shipping-phone" />
      </div>
    </div>
  </>
);
